import { CalculatorReport } from 'modules/salaries/types/CalculatorReport';
import { SalariesCompensationSurveyData } from 'modules/salaries/types/SalariesCompensationSurveyData';
import { SALARIES_API_ENDPOINT_ROOT } from 'modules/salaries/utils/constants/salariesApiEndpointRoot';
import { BackgroundTask } from 'utils/asyncBackendTask';
import { postJson } from 'utils/http/postJson';

export async function salariesSubmitCompensationSurvey(
  compensationSurveyData: SalariesCompensationSurveyData,
): Promise<BackgroundTask<CalculatorReport>> {
  return postJson<{ task: BackgroundTask<CalculatorReport> }>(
    `${SALARIES_API_ENDPOINT_ROOT}${
      compensationSurveyData.source === 'TEST' ? '?test=true' : ''
    }`,
    compensationSurveyData,
  ).then(({ task }) => task);
}
